/**
 * Validation rules for usernames
 */

export function validateUsername(username) {
  if (!username || typeof username !== 'string') {
    return { valid: false, error: 'Le pseudo est requis' };
  }

  const trimmed = username.trim();

  // Length check
  if (trimmed.length < 4) {
    return { valid: false, error: 'Le pseudo doit contenir au moins 4 caractères' };
  }
  if (trimmed.length > 20) {
    return { valid: false, error: 'Le pseudo ne peut pas dépasser 20 caractères' };
  }

  // Character check (only letters, numbers, underscore)
  const validCharsRegex = /^[a-zA-Z0-9_]+$/;
  if (!validCharsRegex.test(trimmed)) {
    return { valid: false, error: 'Seules les lettres, chiffres et _ sont autorisés' };
  }

  // Cannot start or end with underscore
  if (trimmed.startsWith('_') || trimmed.endsWith('_')) {
    return { valid: false, error: 'Le pseudo ne peut pas commencer ou finir par _' };
  }

  // No consecutive underscores
  if (trimmed.includes('__')) {
    return { valid: false, error: 'Le pseudo ne peut pas contenir __ consécutifs' };
  }

  return { valid: true, error: null };
}